// src/pages/AttendancePage.js
import React, { useState, useEffect } from 'react';
import api from '../services/api';
import UniversalSearch from '../components/UniversalSearch';
import ParticipantCard from '../components/ParticipantCard';
import ParticipantDetailModal from '../components/ParticipantDetailModal';
import PipelineStats from '../components/PipelineStats';
import { Divider, Typography, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@mui/material';

const AttendancePage = () => {
  const [searchResults, setSearchResults] = useState([]);
  const [attendedList, setAttendedList] = useState([]);
  const [selectedParticipantId, setSelectedParticipantId] = useState(null);

  const fetchAttendedList = async () => {
    const today = new Date().toISOString().split('T')[0];
    try {
      const response = await api.get(`/api/reports/daily-attendance?report_date=${today}`);
      const sorted = response.data.sort((a,b) => new Date(b.CheckInTime) - new Date(a.CheckInTime));
      setAttendedList(sorted);
    } catch (err) {
      // It's normal for this to fail if no one has checked in yet today
      setAttendedList([]);
    }
  };

  useEffect(() => {
    fetchAttendedList();
  }, []);

  const handleSearch = async (query) => {
    const response = await api.get(`/api/participants/search?query=${query}&status=all`);
    setSearchResults(response.data);
  };

  const openModal = (participantId) => setSelectedParticipantId(participantId);
  const closeModal = (updated) => {
    setSelectedParticipantId(null);
    if (updated) {
      setSearchResults([]);
      fetchAttendedList(); // Refresh the list after an action
    }
  };

  return (
    <>
      <PipelineStats />
      <UniversalSearch
        onSearch={handleSearch}
        title="Daily Attendance"
        placeholder="Search for any participant to check in..."
      />
      {searchResults.map(p => (
        <ParticipantCard
          key={p.ParticipantID}
          participant={p}
          onAction={openModal}
          pipeline="attendance"
        />
      ))}
      
      <Divider sx={{ my: 4 }}><Typography>Attended Today</Typography></Divider>

      <Paper>
        <TableContainer sx={{ maxHeight: 440 }}>
          <Table stickyHeader>
            <TableHead><TableRow><TableCell>Name</TableCell><TableCell>Email</TableCell><TableCell>Check-In Time</TableCell></TableRow></TableHead>
            <TableBody>
              {attendedList.map((p) => (
                <TableRow hover key={p.ParticipantID}>
                  <TableCell>{p.FullName}</TableCell>
                  <TableCell>{p.EmailAddress}</TableCell>
                  <TableCell>{new Date(p.CheckInTime).toLocaleTimeString()}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </Paper>

      {selectedParticipantId && (
        <ParticipantDetailModal
          participantId={selectedParticipantId}
          open={!!selectedParticipantId}
          onClose={closeModal}
        />
      )}
    </>
  );
};

export default AttendancePage;